import React from 'react'
import ReactDOM from 'react-dom'

import client from './common'
import ProductShopLink from './components/productShopLink'

const rootEl = document.querySelectorAll('.react-product-shop-link')

for (let i = 0; i < rootEl.length; i++) {
  const productHandle = rootEl[i].getAttribute('data-product-handle')

  ReactDOM.render(
    <ProductShopLink client={client} productHandle={productHandle} />,
    rootEl[i]
  )
}
